/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export const getExternalHeight = (index) =>
{
  const VALUES = [ /* 0= */ 24, 36, 56, 72, 84, 112 /* 6= */ ];

  return VALUES[index];
};


export const getInternalHeight = (index) =>
{
  const VALUES = [ /* 0= */ 18, 30, 46, 60, 68, 90 /* 6= */ ];

  return VALUES[index];
}


export const getEntitySize = (index) =>
{
  const VALUES = [ /* 0= */ 0, 0, 18, 24, 28, 36 /* 6= */ ];

  return VALUES[index];
}


export const getExternalBorderWidth = (index) =>
{
  const VALUES = [ /* 0= */ 1, 1, 1.5, 2, 2, 2.5 /* 6= */ ];

  return VALUES[index];
}


export const getEmphasizedBorderWidth = (index) =>
{
  const VALUES = [ /* 0= */ 1.5, 1.5, 2, 3.5, 3.5, 4 /* 6= */ ];

  return VALUES[index];
}


export const getGroupBorderWidth = (index) =>
{
  const VALUES = [ /* 0= */ 0, 1, 1, 1, 1, 1.25 /* 6= */ ];

  return VALUES[index];
}


export const getEmphasizedGroupBorderWidth = (index) =>
{
  const VALUES = [ /* 0= */ 0, 1.5, 2, 2, 2, 2.5 /* 6= */ ];

  return VALUES[index];
}


export const getZoneBorderWidth = (index) =>
{
  const VALUES = [ /* 0= */ 0, 0, 0, 0.5, 0.5, 0.5 /* 6= */ ];

  return VALUES[index];
}


export const getDockBorderWidth = (index) =>
{
  const VALUES = [ /* 0= */ 0, 0.5, 0.5, 0.5, 1, 1.5 /* 6= */ ];

  return VALUES[index];
}


export const getJaggedBorderWidth = (index) =>
{
  //const VALUES = [ /* 0= */ 0, 0, 0, 0.5, 0.5, 0.5 /* 6= */ ];

  const VALUES = [ /* 0= */ 0.5, 0.75, 1, 1, 1, 1.25 /* 6= */ ];

  return VALUES[index];
}


export const getJaggedStep = (index) =>
{
  const VALUES = [ /* 0= */ 2, 3, 4.5, 6, 7, 9 /* 6= */ ];

  return VALUES[index];
}


export const getJaggedAmplitude = (index) =>
{
  const VALUES = [ /* 0= */ 0.5, 1, 1.5, 2, 2.5, 3 /* 6= */ ];

  return VALUES[index];
}
